"use client";
import { motion } from "framer-motion";
import { fadeUp } from "@/hooks/useScrollReveal";
import Image from "next/image";

const STATS = [
  {
    value: "40%",
    label: "Reduction in HR admin costs, on average",
    img: "/homepage/stats/stats-1.webp",
  },
  {
    value: "4 hrs",
    label: "Saved weekly per HR admin on attendance alone",
    img: "/homepage/stats/stats-2.webp",
  },
  {
    value: "12 min",
    label: "Average leave approval time, down from 2 days",
    img: "/homepage/stats/stats-3.webp",
  },
];

export default function Stats() {
  return (
    <section className="py-24 md:py-32 bg-muted/30 border-y border-border/60">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <motion.h2
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          className="text-3xl md:text-4xl font-semibold tracking-tight text-foreground mb-2"
        >
          AeronPay customers save hundreds of hours
        </motion.h2>
        <motion.p
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          custom={1}
          variants={fadeUp}
          className="font-display text-3xl md:text-4xl font-semibold italic text-primary mb-16"
        >
          and cut HR costs by 40%
        </motion.p>

        <div className="grid md:grid-cols-3 gap-8 md:gap-0 md:divide-x md:divide-border">
          {STATS.map((stat, i) => (
            <motion.div
              key={stat.img}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeUp}
              className="px-6 flex flex-col justify-between"
            >
              <div className="font-display text-3xl font-semibold text-foreground mb-3">
                {stat.value}
              </div>
              <p className="text-sm text-muted-foreground mb-5 leading-relaxed">
                {stat.label}
              </p>
              <Image src ={stat.img} alt="stats-image"  width={400}
                height={400}/>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
